import FilterDialog from './Dialog'
import { useSelector } from 'react-redux'
import FilterButton from '../../../../filter/FilterButton'

const FilterButtonUser = ({ module = 'dataEntryAssessment'}) => {
  const open = useSelector(state => state?.filter?.[module]?.open || false)

  return (
    <>
      <FilterButton 
        module={module} 
        keysFilter={['yearLevelId', 'templateId']} 
        keepReload={false}
      />
      { open &&
        <FilterDialog module={module} />
      }
    </>
  )
}
export default FilterButtonUser